import React from 'react';
import Skeleton from 'react-loading-skeleton';

import styles from './SkeletonCards.module.scss';

export interface SkeletonCardsProps {
  count: number;
}

export function SkeletonCards({ count }: SkeletonCardsProps) {
  return (
    <>
      <div className={styles.skeletonHeader}>
        <Skeleton width={160} height={24} />
      </div>
      <div className={styles.skeletonCards}>
        {[...Array(count)].map((e, i) => (
          <div className={styles.skeletonCard} key={i}>
            <Skeleton width={225} height={282} />
          </div>
        ))}
      </div>
    </>
  );
}

export default SkeletonCards;
